import React from 'react';
import './ProgressBar.css';

interface ProgressBarProps {
  total: number;
  completed: number;
  analyzing: number;
  failed: number;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ total, completed, analyzing, failed }) => {
  if (total === 0) {
    return <div className="pb__empty">No items to analyze</div>;
  }

  const completedPct = (completed / total) * 100;
  const analyzingPct = (analyzing / total) * 100;
  const failedPct = (failed / total) * 100;
  const pending = total - completed - analyzing - failed;

  return (
    <div className="pb">
      {/* Legend row */}
      <div className="pb__legend">
        {completed > 0 && (
          <span className="pb__legend-item">
            <span className="pb__legend-dot pb__legend-dot--completed"></span>
            Completed <strong>{completed}</strong>
          </span>
        )}
        {analyzing > 0 && (
          <span className="pb__legend-item">
            <span className="pb__legend-dot pb__legend-dot--analyzing"></span>
            Analyzing <strong>{analyzing}</strong>
          </span>
        )}
        {failed > 0 && (
          <span className="pb__legend-item">
            <span className="pb__legend-dot pb__legend-dot--failed"></span>
            Failed <strong>{failed}</strong>
          </span>
        )}
        {pending > 0 && (
          <span className="pb__legend-item">
            <span className="pb__legend-dot pb__legend-dot--pending"></span>
            Pending <strong>{pending}</strong>
          </span>
        )}
      </div>

      {/* Bar */}
      <div className="pb__track">
        {/* Animated shimmer layer behind filled segments */}
        <div className="pb__shimmer" style={{ width: `${completedPct + analyzingPct}%` }}></div>

        <div className="pb__segment pb__segment--completed" style={{ width: `${completedPct}%` }}></div>
        <div className="pb__segment pb__segment--analyzing" style={{ width: `${analyzingPct}%` }}></div>
        <div className="pb__segment pb__segment--failed"    style={{ width: `${failedPct}%` }}></div>
      </div>

      {/* Summary */}
      <div className="pb__summary">
        <span className="pb__pct">{Math.round(completedPct)}%</span>
        <span className="pb__label">
          {completed} of {total} completed
        </span>
      </div>
    </div>
  );
};

export default ProgressBar;
